import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppShell } from '~/components/app-shell'
import { getAppSession } from '~/functions/session.functions'
import { redirectToLogin } from '~/lib/redirect'

/**
 * Everything under here needs a signed-in user. The guard only shapes the UI: the data behind
 * it is protected where it is served (Better Auth endpoints and server function middleware).
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ location }) => {
    const session = await getAppSession()
    if (!session) throw redirectToLogin(location.href)
    return { session }
  },
  component: AuthedLayout,
})

function AuthedLayout() {
  const { session } = Route.useRouteContext()
  return (
    <AppShell session={session}>
      <Outlet />
    </AppShell>
  )
}
